import { render, staticRenderFns } from "./AddSubjectData.vue?vue&type=template&id=7b66b4d8&scoped=true&"
import script from "./AddSubjectData.vue?vue&type=script&lang=js&"
export * from "./AddSubjectData.vue?vue&type=script&lang=js&"
import style0 from "./AddSubjectData.vue?vue&type=style&index=0&id=7b66b4d8&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b66b4d8",
  null
  
)

export default component.exports